export {
  TournamentDetailScreen,
  TournamentDetailScreenLoading,
  TournamentDetailScreenError,
} from './TournamentDetailScreen';
export type { TournamentDetailScreenProps, TabKey } from './TournamentDetailScreen';
